import { render } from "./PayResult.vue?vue&type=template&id=b5a16038&scoped=true&ts=true"
import script from "./PayResult.vue?vue&type=script&lang=ts"
export * from "./PayResult.vue?vue&type=script&lang=ts"

import "./PayResult.vue?vue&type=style&index=0&id=b5a16038&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a16038"]])

export default __exports__